import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { Modal, Button } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toastify } from "../../../helperFunctions/toastify";
import {
  getMonthFromRange,
  getShortMonth,
  formatDate,
  filterTypes,
  getFilterDates,
} from "../../../helperFunctions/utils";
import { thousandAndDecimalFormat } from "../../../utils/common";
import DateInput from "../../SharedComponents/DateInput";

import SelectComponent from "../../SharedComponents/SelectComponent";
import {
  getYearOverYear,
  getSaleYoyRevenueDetail,
} from "../../../apis/dashboardReports";

import DashboardTable from "./DashboardTable";
import LineChart from "./LineChart";

export const costFilterTypes = [
  {
    label: "Revenue",
    value: "R",
  },
  {
    label: "Profit",
    value: "P",
  },
];

const YearOverYear = () => {
  const [yearOverYearResp, setYearOverYearResp] = useState();

  const [rangeMonth, setRangeMonth] = useState({
    r1: [],
    r2: [],
  });

  const [show, setShow] = useState(false);
  const [detailDataResp, setDetailDataResp] = useState([]);
  const [isLoadingDataResp, setIsLoadingDataResp] = useState(true);
  const [selectedDetailData, setSelectedDetailData] = useState({
    typeName: "",
    type: "",
  });
  const [filterType, setFilterType] = useState("last6Months");
  const [filterData, setFilterData] = useState({
    date_range: "M",
    ...getFilterDates(filterType),
    type: "R",
  });
  const [inputFilterData, setInputFilterData] = useState({
    date_range: "M",
    ...getFilterDates(filterType),
    type: "R",
  });

  const getYearOverYearFunc = async () => {
    const response = await getYearOverYear(filterData);
    console.log("year ove year report resp", response);
    if (response.status !== "Fail") {
      setYearOverYearResp(response);
    } else {
      toastify(response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getYearOverYearFunc();
  }, [filterData]);

  useEffect(() => {
    const firstRange = getMonthFromRange(
      filterData.r1_start_date,
      filterData.r1_end_date
    );
    const secondRange = getMonthFromRange(
      filterData.r2_start_date,
      filterData.r2_end_date
    );

    setRangeMonth({
      r1: firstRange,
      r2: secondRange,
    });
  }, [filterData]);

  function formatOutput(period) {
    const periodObject = yearOverYearResp?.find(
      (item) => item.period === period
    );

    if (periodObject) {
      const r1Counts = [];
      const r2Counts = [];

      rangeMonth.r1?.map((monthValue) => {
        r1Counts.push(
          getMonthValue(
            periodObject.r1year,
            monthValue.year,
            monthValue.month + 1
          )
        );
        return false;
      });

      rangeMonth.r2?.map((monthValue) => {
        r2Counts.push(
          getMonthValue(
            periodObject.r2year,
            monthValue.year,
            monthValue.month + 1
          )
        );
        return false;
      });

      return {
        label: period,
        r1year: r1Counts,
        r2year: r2Counts,
      };
    }

    return null; // Return null if the period is not found
  }

  const [revenueFromNewChartData, setRevenueFromNewClvChartData] = useState({
    series: [
      {
        name: "Revenue",
        type: "column",
        data: [],
      },

      {
        name: "Percentage",
        type: "line",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        width: 400,
        type: "line",
      },
      stroke: {
        width: [0, 4],
      },
      title: {
        text: "",
      },
      toolbar: {
        show: false,
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
        formatter: function (value) {
          return thousandAndDecimalFormat(value, true, 2);
        },
      },
      xaxis: {
        type: "Month",
      },
      yaxis: [
        {
          labels: {
            formatter: function (value) {
              return thousandAndDecimalFormat(value, true, 2);
            },
          },
        },
        {
          opposite: true,
          labels: {
            formatter: function (value) {
              return thousandAndDecimalFormat(value, true, 2);
            },
          },
        },
      ],
      colors: ["#408BBFB3", "#FF9232B3"],
    },
  });
  const [revenueFromNewChartData2, setRevenueFromNewClvChartData2] = useState({
    series: [
      {
        name: "Profit",
        type: "column",
        data: [],
      },

      {
        name: "Percentage",
        type: "line",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
      },
      stroke: {
        width: [0, 4],
      },
      title: {
        text: "",
      },
      toolbar: {
        show: false,
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
      },
      xaxis: {
        type: "Month",
      },
      yaxis: [
        {
          labels: {
            formatter: function (value) {
              return thousandAndDecimalFormat(value, true, 2);
            },
          },
        },
        {
          opposite: true,
          labels: {
            formatter: function (value) {
              return thousandAndDecimalFormat(value, true, 2);
            },
          },
        },
      ],
      colors: ["#408BBFB3", "#FF9232B3"],
    },
  });

  useEffect(() => {
    const revenueOutput = formatOutput(
      filterData.type === "R" ? "revenue" : "profit"
    );
    const percentageOutput = formatOutput("percentage");
    if (revenueOutput === null || percentageOutput === null) {
      return;
    }

    const labelarray = [];
    rangeMonth.r1?.map((m, index) => {
      const m2 = rangeMonth.r2[index];
      labelarray.push(`${getShortMonth(m.month)} - ${m.year}`);
      labelarray.push(` ${getShortMonth(m2.month)} - ${m2.year}`);
    });

    const color1 = "#1F77B4";
    const color2 = "#21263c";
    const categoriesCount = labelarray.length;
    const colors = Array.from({ length: categoriesCount }, (_, index) =>
      index % 2 === 0 ? color1 : color2
    );

    const r1yearData = revenueOutput?.r1year || [];
    const r2yearData = revenueOutput?.r2year || [];
    const seriesData = [];

    const r1yearData1 = percentageOutput?.r1year || [];
    const r2yearData1 = percentageOutput?.r2year || [];
    const seriesData1 = [];

    for (let i = 0; i < Math.max(r1yearData.length, r2yearData.length); i++) {
      if (r1yearData[i] !== undefined) {
        seriesData.push(r1yearData[i]);
      }
      if (r2yearData[i] !== undefined) {
        seriesData.push(r2yearData[i]);
      }
    }

    for (let i = 0; i < Math.max(r1yearData1.length, r2yearData1.length); i++) {
      if (r1yearData1[i] !== undefined) {
        seriesData1.push(r1yearData1[i]);
      }
      if (r2yearData1[i] !== undefined) {
        seriesData1.push(r2yearData1[i]);
      }
    }

    setRevenueFromNewClvChartData({
      ...revenueFromNewChartData,
      options: {
        ...revenueFromNewChartData.options,
        labels: labelarray,
        xaxis: {
          categories: labelarray,
          labels: {
            style: {
              colors: colors,
            },
          },
        },
      },
      series: [
        {
          name: inputFilterData.type === "R" ? "Revenue" : "Profit",
          type: "column",
          data: seriesData,
        },
        {
          name:
            inputFilterData.type === "R"
              ? "Percentage of Total Revenue"
              : "Percentage of Total Profit",
          type: "line",
          data: seriesData1,
        },
      ],
    });
  }, [yearOverYearResp]);

  const getMonthValue = (monthValues, year, month) => {
    const monthValue = monthValues.find(
      (m) => m.year === year && m.month === month
    );
    if (!monthValue) return 0;

    if (!monthValue.count) return 0;

    return monthValue.count;
  };

  const getYear = (value) => {
    const date = new Date(value);
    return date.getFullYear();
  };

  const { r1_start_date, r1_end_date, r2_start_date, r2_end_date } =
    inputFilterData;

  function areRangesEqualMonthCount(
    range1StartDate,
    range1EndDate,
    range2StartDate,
    range2EndDate
  ) {
    // Convert string dates to Date objects
    const r1Start = new Date(range1StartDate);
    const r1End = new Date(range1EndDate);
    const r2Start = new Date(range2StartDate);
    const r2End = new Date(range2EndDate);

    // Calculate the month count for both ranges
    const r1MonthCount =
      (r1End.getFullYear() - r1Start.getFullYear()) * 12 +
      (r1End.getMonth() - r1Start.getMonth());
    const r2MonthCount =
      (r2End.getFullYear() - r2Start.getFullYear()) * 12 +
      (r2End.getMonth() - r2Start.getMonth());

    // Check if both ranges have the same number of months
    return r1MonthCount === r2MonthCount;
  }

  const monthSame = areRangesEqualMonthCount(
    r1_start_date,
    r1_end_date,
    r2_start_date,
    r2_end_date
  );

  const handleApplyFilter = () => {
    if (!monthSame) {
      toastify("Both of range need to be match", "error");
    } else {
      setFilterData({
        ...inputFilterData,
      });
    }
  };

  const getTableDetailFunc = async () => {
    setDetailDataResp([]);
    setIsLoadingDataResp(true);
    const { type, typeName, ...rest } = selectedDetailData;
    const response = await getSaleYoyRevenueDetail({
      ...filterData,
      ...rest,
      type: selectedDetailData.type,
    });

    setIsLoadingDataResp(false);
    if (response.status !== "Fail") {
      setDetailDataResp(response?.data?.data);
    } else {
      toastify(response?.data?.message, "error");
    }
  };

  useEffect(() => {
    if (selectedDetailData.type !== "" && selectedDetailData.typeName !== "") {
      getTableDetailFunc();
    }
  }, [selectedDetailData]);

  useEffect(() => {
    setInputFilterData((prevFilterData) => ({
      ...prevFilterData,
      ...getFilterDates(filterType),
    }));
  }, [filterType]);

  // useEffect(() => {
  //   setFilterData((prevFilterData) => ({
  //     ...prevFilterData,
  //     ...getFilterDates(filterType),
  //   }));
  // }, []);
  const [export_PDF, setexportPDF] = useState(false);

  const handleExportPdf = () => {
    setexportPDF(true);

    setTimeout(() => {
      exportPDF();
    }, 1000);
  };
  const exportPDF = () => {
    // have a specific div with an id 'exportArea'
    // that wraps around the elements you want to export.
    const input = document.getElementById("exportArea");
    html2canvas(input, {
      scale: 2,
    }) // scale: 2 to increase the resolution of the screenshot
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7);

        // Initialize jsPDF
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm", // Set the unit to millimeters
          format: "a4", // Set the page format to A4
        });

        // Calculate the number of pages needed for the screenshot.
        const imgWidth = 180; // A4 size page width in mm
        const pageHeight = 297; // A4 size page height in mm
        const marginTop = 10; // Top margin
        const marginBottom = 10; // Bottom margin
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight + marginTop;

        let position = marginTop;

        // Add image to the first page.
        pdf.addImage(
          imgData,
          "JPEG",
          (pdf.internal.pageSize.width - imgWidth) / 2,
          position,
          imgWidth,
          imgHeight - 10
        );
        heightLeft -= pageHeight;

        // Add new pages if the screenshot spans over multiple pages.
        while (heightLeft >= 0) {
          position = marginTop - pageHeight - marginBottom;
          pdf.addPage();
          pdf.addImage(
            imgData,
            "JPEG",
            (pdf.internal.pageSize.width - imgWidth) / 2,
            position,
            imgWidth,
            imgHeight
          );
          heightLeft -= pageHeight;
        }

        // Save the PDF
        const date = new Date();

        pdf.save(`report_${date}.pdf`);
        setexportPDF(false);
      });
  };

  return (
    <div>
      <div className="d-flex flex-wrap gap-3 w-100 px-4 py-4">
        <div className="drop-down-box col-2 me-2">
          <div className="font-400-20 mb-1">Date Presets:</div>
          <SelectComponent
            options={filterTypes}
            selectedValue={filterType}
            singleSelect
            searchEnabled
            nullDisabled
            onChange={(e) => {
              setFilterType(e.value);
              setInputFilterData({ ...inputFilterData, date_range: e.value });
            }}
          />
        </div>
        <div className="range-1">
          <div className="font-400-20 mb-2">Range 1:</div>
          <div className="date-selector-box">
            <DateInput
              value={inputFilterData.r1_start_date}
              placeholder="Start Date"
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r1_start_date: formattedDate,
                });
              }}
            />
            -
            <DateInput
              placeholder="End Date"
              value={inputFilterData.r1_end_date}
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r1_end_date: formattedDate,
                });
              }}
            />
          </div>
        </div>
        <div className="range-2">
          <div className="font-400-20 mb-2">Range 2:</div>
          <div className="date-selector-box">
            <DateInput
              value={inputFilterData.r2_start_date}
              placeholder="Start Date"
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r2_start_date: formattedDate,
                });
              }}
            />
            -
            <DateInput
              placeholder="End Date"
              value={inputFilterData.r2_end_date}
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r2_end_date: formattedDate,
                });
              }}
            />
          </div>
        </div>
        <Button
          className="addItem align-self-end"
          style={{ height: "47px" }}
          onClick={() => handleApplyFilter()}
        >
          Apply
        </Button>
        <Button
          className="addItem align-self-end"
          style={{ height: "47px" }}
          onClick={() => {
            handleExportPdf();
          }}
        >
          Export
        </Button>

        <div className="col-12">
          <div className="drop-down-box col-2 me-2">
            <div className="font-400-20 mb-1">Type:</div>
            <SelectComponent
              options={costFilterTypes}
              selectedValue={inputFilterData.type}
              singleSelect
              searchEnabled
              nullDisabled
              onChange={(e) => {
                setInputFilterData({ ...inputFilterData, type: e.value });
              }}
            />
          </div>
        </div>
      </div>
      <div className="age-block" id="exportArea">
        <div className="demographic-page-block">
          <h1 className="block-heading">
            {/* Year-Over-Year Growth Revenue Reports */}
          </h1>
          <div
            className="graphs-block"
            style={{ gridTemplateColumns: "repeat(1, 1fr)" }}
          >
            <div className="graph-item">
              <h2 className="year-title">
                {formatDate(filterData.r1_start_date)} -{" "}
                {formatDate(filterData.r1_end_date)}
                &nbsp;&nbsp;|&nbsp;&nbsp;
                {formatDate(filterData.r2_start_date)} -{" "}
                {formatDate(filterData.r2_end_date)}
              </h2>
              <LineChart chartData={revenueFromNewChartData} />
            </div>
          </div>
        </div>

        <DashboardTable
          name="yearOverYearResp"
          filterData={filterData}
          rangeMonth={rangeMonth}
          values={yearOverYearResp}
          firstField="year"
          secondField="year"
          setShow={setShow}
          setSelectedDetailData={setSelectedDetailData}
          export_pdf={export_PDF}
          showPercentage={true}
        />
      </div>
      <Modal
        className=""
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Header closeButton className="pb-0" style={{ borderWidth: 0 }}>
          <div
            className="d-flex w-100 justify-content-center p-0 alert-heading"
            style={{ fontSize: "1rem" }}
          >
            {selectedDetailData.typeName.charAt(0).toUpperCase() +
              selectedDetailData.typeName.slice(1)}{" "}
            From: {filterData.r1_start_date} - {filterData.r1_end_date}
            &nbsp;&nbsp;To:&nbsp;&nbsp;
            {filterData.r2_start_date} - {filterData.r2_end_date}
          </div>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "scroll", maxHeight: 400 }}>
          <div className="mode-table-block">
            <div className="table-header">
              <div className="table-col">
                <h3 className="col-title">Date</h3>
              </div>
              <div className="table-col">
                <h3 className="col-title">Patient Name</h3>
              </div>
              {/* <div className="table-col">
                <h3 className="col-title">Source/Recommend By</h3>
              </div> */}
              <div className="table-col">
                <h3 className="col-title">Amount</h3>
              </div>
            </div>
            {!isLoadingDataResp ? (
              <>
                {detailDataResp
                  ?.filter((a) => a?.amount != null || a?.amount != 0)
                  ?.map((item, index) => (
                    <div key={index} className="table-rows">
                      <div className="table-col">
                        <h3 className="col-title">
                          {formatDate(item.created_at)}
                        </h3>
                      </div>
                      <div className="table-col">
                        <h3 className="col-title">{item.fullName || "-"}</h3>
                      </div>
                      {/* <div className="table-col">
                      <h3 className="col-title">{item.recommendFrom || "-"}</h3>
                    </div> */}
                      <div className="table-col">
                        <h3 className="col-title"> {item.amount || "-"}</h3>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <span className="d-flex justify-content-center p-2">
                <CircularProgress />
              </span>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default YearOverYear;
